import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import HeaderNav from "./components/aura/HeaderNav";
import KineticHero from "./components/aura/KineticHero";
import MarqueeTicker from "./components/aura/MarqueeTicker";
import ClassSchedule from "./components/aura/ClassSchedule";
import BentoGallery from "./components/aura/BentoGallery";
import Pricing from "./components/aura/Pricing";
import Instructor from "./components/aura/Instructor";
import Contact from "./components/aura/Contact";
import Footer from "./components/aura/Footer";
import PaymentResult from "./components/aura/PaymentResult";

const PAYMENT_PATHS = {
    "/payment/success": "success",
    "/payment/cancel": "cancel",
};

export default function App() {
    const paymentType = PAYMENT_PATHS[window.location.pathname];
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, anchors: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-cream font-sans text-ink">
            <Toaster position="top-center" richColors />
            {paymentType ? (
                <PaymentResult type={paymentType} />
            ) : (
                <>
                    <HeaderNav />
                    <main>
                        <KineticHero />
                        <MarqueeTicker />
                        <ClassSchedule />
                        <BentoGallery />
                        <Pricing />
                        <Instructor />
                        <Contact />
                    </main>
                    <Footer />
                </>
            )}
        </div>
    );
}
